import { RcFile } from 'antd/lib/upload';
import { IPOUtils } from '@hylaa-npm/ipod';
import { uploadFileInfo, uploadFileData, uploadFileState } from '@/apis/upload';
import { BASEURL } from '@/apis';

export const uploadFile: (file: RcFile | undefined) => Promise<boolean | IFile> = async (file) => {
	if (!file) {
		return false;
	}

	const fileInfo: IFile = await uploadFileInfo({ name: file.name, size: file.size });

	//提交将上传的文件信息

	const fileId = fileInfo.id;
	const formData = new FormData();
	formData.append('file', file);
	formData.append('partIndex', '1');
	formData.append('startPosition', '0');

	await uploadFileData(fileId, formData);
	let fileData: IFile = await uploadFileState(fileId);
	return new Promise((resolve) => resolve(fileData));
};

export const downloadFile = (file: { name: string; fileId: string }) => {
	let downloadUrl = IPOUtils.downloadFileUrl(BASEURL, file.fileId);
	window.open(downloadUrl, '_self');
};
